
(()=>{const el=document.querySelector('[data-ss-countdown]');if(!el)return;const target=new Date('2026-09-01T09:00:00+01:00').getTime();const fields={d:el.querySelector('[data-days]'),h:el.querySelector('[data-hours]'),m:el.querySelector('[data-minutes]'),s:el.querySelector('[data-seconds]')};const tick=()=>{const left=Math.max(0,target-Date.now());fields.d.textContent=String(Math.floor(left/86400000)).padStart(2,'0');fields.h.textContent=String(Math.floor(left/3600000)%24).padStart(2,'0');fields.m.textContent=String(Math.floor(left/60000)%60).padStart(2,'0');fields.s.textContent=String(Math.floor(left/1000)%60).padStart(2,'0')};tick();setInterval(tick,1000)})();


/* SchoolSmart mobile navigation dropdown positioning */
(()=>{
  const mobileQuery=window.matchMedia('(max-width: 749px)');
  const positionOpenSubmenus=()=>{
    if(!mobileQuery.matches)return;
    document.querySelectorAll('#header-component .header__navigation-bar-row .menu-list__disclosure[aria-expanded="true"]').forEach(button=>{
      const item=button.closest('.menu-list__list-item');
      const submenu=item?.querySelector(':scope > .menu-list__submenu');
      const nav=button.closest('.header__navigation-bar-row');
      if(!submenu||!nav)return;
      submenu.style.setProperty('--ss-mobile-submenu-top',Math.max(0,nav.getBoundingClientRect().bottom)+'px');
    });
  };
  document.addEventListener('click',event=>{
    const button=event.target.closest?.('#header-component .header__navigation-bar-row .menu-list__disclosure');
    if(!button||!mobileQuery.matches)return;
    requestAnimationFrame(positionOpenSubmenus);
  });
  window.addEventListener('resize',positionOpenSubmenus,{passive:true});
  window.addEventListener('scroll',positionOpenSubmenus,{passive:true});
})();
